import type { Report } from "@flareapp/js";
import { redact } from "@smakecloud/browser-telemetry";

/**
 * A Flare report with the shared redaction rules (the same as the Faro
 * telemetry): tokens, /entrance?t=&r=, e-mail addresses, S3 signatures,
 * cookies. Flare also sends the query string on its own (`url.query`), where
 * the /entrance rule cannot see the path and the refresh token would stay, so
 * it is rebuilt from the redacted `url.full`.
 */
export function redactFlareReport(report: Report): Report {
    // depth 16 like the package's OTLP payloads; reports are flatter, but a
    // truncated report would be useless
    const redacted = redact(report, { maxDepth: 16 });
    const url = redacted.attributes["url.full"];

    if (typeof url === "string" && "url.query" in redacted.attributes) {
        redacted.attributes["url.query"] = queryString(url);
    }

    return redacted;
}

function queryString(url: string): string {
    const [withoutHash = ""] = url.split("#", 1);
    const start = withoutHash.indexOf("?");

    return start === -1 ? "" : withoutHash.slice(start + 1);
}
